import { Layout } from 'antd'
import { Outlet } from 'react-router-dom'

import { ErrorBoundary } from '@/containers/views/error-boundary/ErrorBoundary'
import { useApp } from '@/hooks/useApp'
import { type HOCProps } from '@/interfaces/common'

import { Topbar } from './topbar'
import { AppState } from '@/state'
import { useCheckPathAccess } from '@/hooks/useAuth'

interface AppProps extends HOCProps {}

const { Content } = Layout

interface Styles {
  content: React.CSSProperties
  layout: React.CSSProperties
}

const { height } = AppState

const styles: Styles = {
  content: {
    background: '#f1f3f6',
    flexShrink: 0,
    padding: '30px',
    marginTop: '50px',
  },
  layout: {
    flexDirection: 'row',
    overflowX: 'hidden',
    height: height.value,
  },
}

export const Dashboard: React.FunctionComponent<AppProps> = (
  props: AppProps
) => {
  const { size } = useApp()
  useCheckPathAccess()

  return (
    <Layout style={{ height: size.value.height }}>
      <Topbar />
      <Layout style={styles.layout}>
        {/* <Sidebar /> */}
        <Layout
          className='isoContentMainLayout'
          style={{
            height: height.value,
            overflowY: 'auto',
          }}
        >
          <Content style={styles.content}>
            <ErrorBoundary>
              <Outlet />
            </ErrorBoundary>
          </Content>
        </Layout>
      </Layout>
    </Layout>
  )
}
